import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import Form                         from "react-jsonschema-form";
import { schema, uiSchema }         from "../../components/assessment/schema/LowerBodyPower"
import { invokeSetAddLowerBodyPowerAssessment,
         invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import '../../css/assessment/HeartAndBloodForm.css';

//const log = (type) => console.log.bind(console, type);
// FORM DOCS: https://react-jsonschema-form.readthedocs.io/en/latest/#react-jsonschema-form

const onError = (errors) => console.log("I have", errors.length, "errors to fix");

let assess_form;

export default class LowerBodyPowerForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            userFormData: {}
        }

       this.setUserFormData = this.setUserFormData.bind(this);
    }

    async componentWillMount () {
        var assessment_id = this.props.assessmentId;

        if(assessment_id != "undefined") {
            var action     = "existing";
            var client_id        = this.props.clientId;
            var assessment_id    = this.props.assessmentId;

            var screen = "getLowerBodyPowerAssessment";
            const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);

            if(results) {
                //vertical_jump, broad_jump, lateral_bound_left, lateral_bound_right
                var vertical_jump       = results.data[0].vertical_jump;
                var broad_jump          = results.data[0].broad_jump
                var lateral_bound_left  = results.data[0].lateral_bound_left
                var lateral_bound_right = results.data[0].lateral_bound_right

                this.setState({
                    userFormData: {
                        vertical_jump:       vertical_jump,
                        broad_jump:          broad_jump,
                        lateral_bound_left:  lateral_bound_left,
                        lateral_bound_right: lateral_bound_right
                    }
                });
            }
        } else {
            this.setUserFormData("", "", "", "");
        }
    }

    setUserFormData(vertical_jump, broad_jump, lateral_bound_left, lateral_bound_right) {
        this.setState({
            userFormData: {
                vertical_jump:       vertical_jump,
                broad_jump:          broad_jump,
                lateral_bound_left:  lateral_bound_left,
                lateral_bound_right: lateral_bound_right
            }
        });
    }

    isObject(obj) {
        return obj != null && obj.constructor.name === "Object"
    }

    onSubmit = async (formData) => {
        var client_id        = this.props.clientId;
        var assessment_id    = this.props.assessmentId;
        var assessment_type  = 5; // heart and blood is #4 in dropdown

        var action = "";
        if(assessment_id === "undefined") action = "new";

        var exists = this.props.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        this.setState({
            isLoading: true
        })

        var obj = this.getObjectData(formData);

        var vertical_jump       = obj.vertical_jump;
        var broad_jump          = obj.broad_jump;
        var lateral_bound_left  = obj.lateral_bound_left;
        var lateral_bound_right = obj.lateral_bound_right;

        var results = await this.props.addAssessmentToDB(assessment_type);

        if(results.status === true) {
            var assessment_id = results.assessment_id;

            var results2 = await invokeSetAddLowerBodyPowerAssessment(action, assessment_id, client_id, vertical_jump, broad_jump, lateral_bound_left, lateral_bound_right)

            if(results2.status === true)
                this.props.cancelAssessment();
        } else
            this.setState({
                isLoading: false
            })
    }

    getObjectData = (formData) => {
        var vertical_jump;
        var broad_jump;
        var lateral_bound_left
        var lateral_bound_right;

        for(var key in formData) {
            var formData2 = formData[key];
            for(var key2 in formData2) {
                var data = formData2[key2];

                if(key2 === "vertical_jump" && this.isObject(data) == false)
                    vertical_jump = data;
                else if(key2 === "broad_jump" && this.isObject(data) == false)
                    broad_jump = data;
                else if(key2 === "lateral_bound_left" && this.isObject(data) == false)
                    lateral_bound_left = data;
                else if(key2 === "lateral_bound_right" && this.isObject(data) == false)
                    lateral_bound_right = data;
            }
        }
        var obj = {};
        obj.vertical_jump      = vertical_jump;
        obj.broad_jump         = broad_jump
        obj.lateral_bound_left = lateral_bound_left
        obj.lateral_bound_right = lateral_bound_right

        return obj;
    }

    onChange = (formData) => {
        var obj = this.getObjectData(formData);

        var vertical_jump       = obj.vertical_jump;
        var broad_jump          = obj.broad_jump;
        var lateral_bound_left  = obj.lateral_bound_left;
        var lateral_bound_right = obj.lateral_bound_right;

        this.setUserFormData(vertical_jump, broad_jump, lateral_bound_left, lateral_bound_right);
    }


    createForm () {
            return <Form  style      = {{textAlign:"left", fontSize: "20px !important"}}
                          className  = "assessmentHeartAndBloodForm"
                          schema     = {schema}
                          uiSchema   = {uiSchema}
                          formData   = {this.state.userFormData}
                          onChange   = {this.onChange} ref={(form) => {assess_form = form}}
                          onSubmit   = {this.onSubmit} ref={(form) => {assess_form = form}}
                          noValidate = {true}
                    >
                            <Row className="grid" >
                                  <Col xs={6} sm={6} md={6}>
                                        <span onClick = { () => this.props.cancelAssessment()}
                                            style={{display:"inline-block", paddingLeft: "20px !important", width:"100%"}}>
                                              <LoaderButton
                                                block
                                                type    = "button"
                                                text    = "Cancel"
                                                style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                              />
                                        </span>
                                  </Col>
                                  <Col xs={6} sm={6} md={6}>
                                        <span style={{position: "relative", left:30, display:"inline-block", width:"100%"}}>
                                              <LoaderButton
                                                block
                                                style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                                //disabled={!this.validateForm()}
                                                isLoading={this.state.isLoading}
                                                text    = "Save"
                                                type    = "submit"
                                                loadingText="Saving …"
                                              />
                                        </span>
                                    </Col>
                             </Row>
                     </Form>
    }

    render() {
        var form = this.createForm();

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                { form }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/LowerBodyPowerForm.js